// extracted by mini-css-extract-plugin
export var layoutContainer = "_bk-0";
export var layoutContainerNoRounding = "_bk-6";
export var layoutContainerOpen = "_bk-5";
export var layoutContainerResizing = "_bk-1";
export var mainContent = "_bk-2";
export var resizeDivider = "_bk-3";
export var slidePanel = "_bk-4";